<div id="main-content" class="wrapper has-padding margin-height zoom-margin" (focusout)="onFocusOutMainContent($event)">
  <form *ngIf="consentData ;  else loading" [formGroup]="consentGroup" (ngSubmit)="onSubmit()">
    <div class="max-width-1024">
      <h2 class="bofa--heading is-4">Certification</h2>
      <div [innerHTML]="consentInstruction"></div>

      <mat-checkbox formControlName="certificationCheck" (click)="onChangecertificationCheck()"
        class="minor-check-padding" aria-required="true" required (focusout)="consentOnBlur()"
        (focusin)="consentOnFocus()">
        <mat-label><abbr title="required">* </abbr><span class="white-space-normal"
            [innerHTML]="consentCheckInstruction"></span><span class="white-space-normal"> I further understand and
            agree to the information presented. </span>
        </mat-label>
      </mat-checkbox>
      <mat-error class="white-space-normal" *ngIf="submit.value && certificationCheck.hasError('required') && check">
        Please check the box to agree to the above language
      </mat-error>

      <mat-form-field class="max-zoom margin-width">
        <mat-label>Certification date and time</mat-label>
        <input matInput value="{{ date }}" matInput disabled>
      </mat-form-field>

      <div class="margin-max" *ngIf="consentData">
        <app-wet-signature [signatureImg]="signatureImg" (sigURL)="getUrl($event)" (sigCheck)="sigCheck($event)">
        </app-wet-signature>
        <mat-error *ngIf="output.hasError('invalid') || sigCheckValue"> Please enter electronic signature </mat-error>
      </div>

      <div *ngIf="showOusAttachments">
        <p id="required" class="global-red bofa--heading is-6 has-no-margin bottom-space">Required Documentation </p>
        <div class="bofa--alert has-background cool-gray-5 has-padding level-text">
          <span class="padding-10"> <img alt="information" src="assets/bofa_icon_info.svg"
              class="img-size"></span>
          <span class="font-size-14">Completed documents must be uploaded on the Certification tab prior to
            submitting the form.</span>
        </div>

        <div *ngIf="!consentChange">
          <!-- set focus when incomplete -->
          <div tabindex="-1" #addElement class="bofa--skiplink">
          </div>

          <table [class.border-red]="border" aria-labelledby="required" mat-table [dataSource]="ousDataSource">
            <ng-container matColumnDef="attachmentName">
              <td mat-cell *matCellDef="let element">
                <span *ngIf="element.downloadble === 1"><a
                    href="/bsiAF/api/downloadOUSParentDocument?ousAttachmentID={{element.attachmentId}}&verifyId={{verifyId.value}}"
                    class="af-anchor" aria-label="download {{element.attachmentName}}"> {{element.attachmentName }}
                  </a></span>
                <div class="name-link">
                  <span *ngIf="element.downloadble !== 1">{{element.attachmentName}}</span>
                  <span *ngIf="element.attachmentId === 32">
                    <a href="javascript:void(0)" target="_blank" rel="noopener noreferrer" (click)="loadDocumentHelp()"
                      aria-label="valid document help link">Valid document help link</a>
                  </span>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="downloadble">
              <td mat-cell *matCellDef="let element">
                <div>
                  <button type="button" class="bofa--button secondary outlined height-padding" color="primary"
                    [disabled]="element.attachmentCheck || formSubmitted "
                    (click)="openFileDialog(true ,element.attachmentId )" aria-label="attach required file">
                    <div class="button-content">
                      <span> <img class="width-height-margin" alt="Document"
                          src="assets/icon_document.svg"></span>
                      <span class="padding-10"> Attach file </span>
                    </div>
                  </button>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="attachmentId">
              <td mat-cell *matCellDef="let element">
                <mat-checkbox [disabled]="true" [checked]="element.attachmentCheck">
                  <mat-label class="bofa--skiplink">box</mat-label>
                </mat-checkbox>
              </td>
            </ng-container>
            <tr mat-row *matRowDef="let row; columns: displayedOusColumns;"></tr>
          </table>
        </div>

        <!-- On Zoom -->
        <div *ngIf="consentChange">
          <!-- set focus when incomplete -->
          <div tabindex="-1" #addElement class="bofa--skiplink">
          </div>
          <table [class.border-red]="border" aria-labelledby="required" #addElement class="mat-table-space" mat-table
            [dataSource]="ousDataSource">
            <ng-container matColumnDef="attachmentName">
              <td mat-cell *matCellDef="let element">
                <span class="margin-top" *ngIf="element.downloadble === 1"><a
                    href="/bsiAF/api/downloadOUSParentDocument?ousAttachmentID={{element.attachmentId}}&verifyId={{verifyId.value}}"
                    class="af-anchor" aria-label="download {{element.attachmentName}}"> {{element.attachmentName }}
                  </a></span>
                <div class="name-link">
                  <span *ngIf="element.downloadble !== 1">{{element.attachmentName}}</span>
                  <span *ngIf="element.attachmentId === 32">
                    <a href="javascript:void(0)" target="_blank" rel="noopener noreferrer" (click)="loadDocumentHelp()"
                      aria-label="valid document help link">Valid document help link</a>
                  </span>
                </div>

                <div class="zoom-attach">
                  <button type="button" class="bofa--button secondary outlined height-padding" color="primary"
                    [disabled]="element.attachmentCheck || formSubmitted "
                    (click)="openFileDialog(true ,element.attachmentId )" aria-label="attach required file">
                    <span> <img class="width-height-margin" alt="" src="assets/icon_document.svg"></span>
                    <span class="padding-10"> Attach file </span>
                  </button>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="downloadble">
              <td mat-cell *matCellDef="let element">
              </td>
            </ng-container>

            <ng-container matColumnDef="attachmentId">
              <td mat-cell *matCellDef="let element">
                <mat-checkbox [disabled]="true" [checked]="element.attachmentCheck">
                </mat-checkbox>
              </td>
            </ng-container>
            <tr mat-row *matRowDef="let row; columns: displayedOusColumns;"></tr>
          </table>
        </div>
      </div>

      <div class="padding-top-8" *ngIf="isMinor">
        <mat-card appearance="outlined" class="af-mat-card mat-elevation-z">
          <mat-card-header>

            <mat-card-title class="text-max"><abbr title="required">* </abbr>Based on your date of birth, you must
              attach an Under 18
              Consent Form before submitting your application:</mat-card-title>
          </mat-card-header>
          <mat-card-content>

            <div class="line-height-18">
              <ol type="1">
                <li>Download and print the <u><a target="_blank" rel="noopener noreferrer" class="af-anchor"
                      href='assets/Under_18_Consent_Form.pdf' aria-label="under 18 consent form">Under 18 Consent
                      Form</a></u>.</li>
                <li>
                  Have your parent/guardian complete the form and <strong>get it notarized.</strong>
                </li>
                <li>
                  Log back into this site, attach the completed form and submit your application.
                </li>
                <li>
                  Your Staffing representative will receive and validate your form is completed correctly.
                </li>
              </ol>
              <strong>Note:</strong> If not correct, the system will reject the attachment and you will receive an email
              instructing you to attach a completed form.
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <h3 class="global-red bofa--heading is-5 ">Other attachments</h3>
      <div class="flex-container">
        <mat-card appearance="outlined" class="af-mat-card mat-elevation-z fx-flex-50">
          <mat-card-header>
            <div mat-card-avatar class="example-header-image">
              <img alt="information" src="assets/bofa_icon_info.svg" class="img-size">
            </div>
            <h4 class="mat-mdc-card-title">Other Attachments are optional</h4>
          </mat-card-header>
          <mat-card-content>
            <p>If you had any gaps within your employment history in the last 5 years, please upload
              documentation for explanation of this gap. You may also attach any additional documents
              evidencing your education, previous employment or professional qualifications.</p>
          </mat-card-content>
        </mat-card>

        <mat-card appearance="outlined" class="af-mat-card mat-elevation-z fx-flex-45">
          <mat-card-header>
            <div mat-card-avatar class="example-header-image">
              <img alt="information" src="assets/bofa_icon_info.svg" class="img-size">
            </div>
            <h4 class="mat-mdc-card-title">Allowed file formats</h4>
          </mat-card-header>
          <mat-card-content>
            <p class="bofa--heading is-9">ZIP, PDF, DOC, DOCX, EML, MSG, TIFF, JPEG, GIF, XLS, XLSX, PNG, JPG, PPT and
              PPTX
            </p>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="is-stacked">
        <button type="button" class="bofa--button secondary outlined height-padding" color="primary"
          [disabled]="formSubmitted" (click)="openFileDialog(false)" aria-label="attach optional file">
          <span> <img class="width-height-margin" alt="Document" src="assets/icon_document.svg"></span> <span
            class="padding-10"> Attach file</span>
        </button>
      </div>

      <div class="table-container bottom-space">
        <span class="hide" id="tableDesc">Attached files</span>
        <table mat-table aria-labelledby="tableDesc" [dataSource]="dataSource">
          <ng-container matColumnDef="fileName">
            <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>File Name</th>
            <td mat-cell *matCellDef="let element">
              <button type="button" class="bofa--button secondary outlined" title="Download Attachment {{element.fileName}}" 
                aria-label="download {{element.fileName}}" 
              (click)="downloadAttachment(element.mongoAttachmentId, element.fileName)">{{element.fileName}}
              </button>

            </td>
          </ng-container>

          <ng-container matColumnDef="descOfFileName">
            <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let element"> {{element.descOfFileName}} </td>
          </ng-container>

          <ng-container matColumnDef="fileType">
            <th scope="col" mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let element"> {{element.fileType}} </td>
          </ng-container>

          <ng-container matColumnDef="fileSize">
            <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Size (In Bytes)</th>
            <td mat-cell *matCellDef="let element"> {{element.fileSize}} </td>
          </ng-container>

          <ng-container matColumnDef="attachedBy">
            <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Attached by</th>
            <td mat-cell *matCellDef="let element"> {{element.attachedBy}} </td>
          </ng-container>

          <ng-container matColumnDef="attachedDateString">
            <th scope="col" class="cell-width" mat-header-cell *matHeaderCellDef>Date attached</th>
            <td mat-cell *matCellDef="let element"> {{element.attachedDateString}} </td>
          </ng-container>
          <ng-container matColumnDef="remove">
            <th scope="col" class="text-center" mat-header-cell *matHeaderCellDef>Action</th>
            <td class="text-center" mat-cell *matCellDef="let element"> <span role="button" *ngIf="!formSubmitted"
                tabindex="0" (click)="removeAttachment(element.mongoAttachmentId,element.typeOfAttachmentId)"
                (keyup.enter)="removeAttachment(element.mongoAttachmentId,element.typeOfAttachmentId)"
                class="af-anchor">
                Remove <span class="hide">&nbsp;{{ element.fileName }}</span></span></td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns ; "></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator aria-label="Attached files pagination" [pageSizeOptions]="[ 10, 20 ]"
          showFirstLastButtons></mat-paginator>
      </div>

      <div class="bottom-space">
        <mat-checkbox formControlName="consentLegalRequirementsMet" aria-required="true" required
          (focusout)="legalOnBlur()" (focusin)="legalOnFocus()" class="minor-check-padding">
          <mat-label class="white-space-normal"><abbr title="required">* </abbr> Yes, I certify that I have read and
            understand the information
            presented.
          </mat-label>
        </mat-checkbox>
        <mat-error class="white-space-normal"
          *ngIf="submit.value && consentLegalRequirementsMet.hasError('required') && checkTwo">
          Please check the box to agree to the above language.
        </mat-error>
      </div>

      <div>
        <mat-form-field class="max-zoom width-margin-top-bottom" hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>Please enter your full name</mat-label>
          <input matInput placeholder="Full name" formControlName="consentApplicantSignedName" required maxlength="250">
          <mat-error>Please enter your full name</mat-error>
        </mat-form-field>
      </div>

      <mat-form-field class="max-zoom" class="width-350">
        <mat-label>Date signed</mat-label>
        <input matInput value="{{ legalRequirementCheckDate }}" matInput disabled>
      </mat-form-field>
    </div>
  </form>
</div>

<ng-template #loading>
  Loading consent data...
</ng-template>